export enum FundraisingType {
  PRIVATE = 'PRIVATE',
  CROWDFUNDING = 'CROWDFUNDING',
}
